import React, { useState } from "react";
import { Link } from "react-router-dom";
import { signup } from "../auth/helper";
import "../css/signin.css";
import Basefooter from "./Basefooter";
import Baseheader from "./Baseheader";
const Signup = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    error: "",
    success: false,
  });

  const { name, email, password, error, success } = values;

  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setValues({ ...values, error: false });
    signup({ name, email, password })
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error, success: false });
        } else {
          setValues({
            ...values,
            name: "",
            email: "",
            password: "",
            error: "",
            success: true,
          });
        }
      })
      .catch(console.log("Error in signup"));
  };

  const signUpForm = () => {
    return (
      <div className="mainform">
        <form>
          <div className="form-group">
            <label className="text-light">Name</label>
            <input
              className="form-control"
              onChange={handleChange("name")}
              type="text"
              value={name}
            />
          </div>
          <div className="form-group">
            <label className="text-light">Email</label>
            <input
              className="form-control"
              onChange={handleChange("email")}
              type="text"
              value={email}
            />
          </div>

          <div className="form-group">
            <label className="text-light">Password</label>
            <input
              onChange={handleChange("password")}
              className="form-control"
              type="password"
              value={password}
            />
          </div>
          <div className="submitbtndiv">
            <button onClick={onSubmit} className="sumbitbtn">
              Submit
            </button>
          </div>
        </form>
      </div>
    );
  };

  const successMessage = () => {
    return (
      <div className="alert-success" style={{ display: success ? "" : "none" }}>
        New account was created successfully. Please
        <Link to="/signin">Login Here</Link>
      </div>
    );
  };

  const errorMessage = () => {
    return (
      <div className="alert-danger" style={{ display: error ? "" : "none" }}>
        {error}
      </div>
    );
  };

  return (
    <div>
      <Baseheader />
      <div className="mainbox">
        {successMessage()}
        {errorMessage()}
        {signUpForm()}
      </div>
      <Basefooter />
    </div>
  );
};

export default Signup;
